export const matchMedia = (size = 'md') => {
  switch (size) {
    case 'sm':
      return window.matchMedia('(min-width: 640px)');
    case 'md':
      return window.matchMedia('(min-width: 768px)');
    case 'lg':
      return window.matchMedia('(min-width: 1025px)');
    case 'xl':
      return window.matchMedia('(min-width: 1280px)');
    case 'under_lg':
      return window.matchMedia('(max-width: 1024px)');
    default:
      return window.matchMedia('(min-width: 0px)');
  }
};
